import { Button } from 'react-bootstrap';

/** Shows shared request feedback while keeping available report details visible during updates. */
const SpecialReportWidgetState = ({
  title,
  isFetching,
  isError,
  hasData,
  onRetry,
  emptyMessage,
  children,
}) => (
  <>
    {isFetching && hasData && (
      <p className="small mb-2" role="status">
        Updating {title.toLowerCase()}...
      </p>
    )}
    {isError && (
      <div
        className="d-flex align-items-center flex-wrap gap-2 border rounded-2 p-2 mb-2"
        role="alert"
      >
        <p className="small m-0 flex-grow-1">
          {hasData
            ? `Unable to update ${title.toLowerCase()}. Showing the last available results.`
            : `Unable to load ${title.toLowerCase()}. Please try again.`}
        </p>
        <Button size="sm" onClick={onRetry} disabled={isFetching}>
          Retry
        </Button>
      </div>
    )}
    {hasData
      ? children
      : !isError && (
          <p className="small m-0 p-2" role="status">
            {emptyMessage}
          </p>
        )}
  </>
);

export default SpecialReportWidgetState;
